// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__NL6VK","nav__list":"Nav_nav__list__cqEma","nav__link":"Nav_nav__link__CiKxI","nav__link_active":"Nav_nav__link_active__qy3Qk"};